

















































































































































































import { isUndefined, isEmpty } from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import { NavigationGuardNext, Route } from 'vue-router'

import CenteredColumnLayout from '../../../../components/CenteredColumnLayout.vue'
import { errorNotificationWrapper } from "../../../../logic/helpers/NotificationService";
import { tgLoginLink, atSignedLogin } from '../../../../shared/utils/tgLoginHelpers'
import Payment, { NoticePayInfo, NoticeBotInfo } from '../../includes/logic/Payment'

Component.registerHooks([
  'beforeRouteEnter',
])

@Component({
  components: {
    CenteredColumnLayout
  },
  methods: {
    isEmpty,
    tgLoginLink,
    atSignedLogin
  },
})
export default class NoticePaymentStatus extends Vue {
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext): void {
    if (isUndefined(to.query.invoiceData)) {
      next({ name: 'error_404' })
    }
    next()
  }

  invoiceData = ''

  invoice: NoticePayInfo | null = null

  bot: NoticeBotInfo | null = null

  url = ''

  companyDetails = {
    name: this.$store.state.AdminTemplate.applicationConfig.meta.projectName,
    siteUrl: this.$store.state.AdminTemplate.applicationConfig.meta.projectDomain,
  }

  loading = false

  async mounted(): Promise<void> {
    this.invoiceData = this.$route.query.invoiceData as string
    this.loading = true
    try {
      const { data } = await Payment.getNoticePayInfo(this.invoiceData)

      this.invoice = data.notice
      this.bot = data.bot
      this.url = data.url
    } catch (error) {
      errorNotificationWrapper(this.$t('error').toString(), error)
    } finally {
      this.loading = false
    }
  }
}
